import { EVENT_TYPES } from './chats.mjs';
import { urlToShareId } from './attachments.mjs';

export function classifyEventMessage(message) {
  const detail = message?.eventDetail;
  if (!detail) return null;
  const type = detail['@odata.type'];
  if (type === EVENT_TYPES.CALL_RECORDING) {
    return {
      kind: 'recording',
      url: detail.callRecordingUrl || null,
      displayName: detail.callRecordingDisplayName || 'Meeting Recording',
      duration: detail.callRecordingDuration || null,
      callId: detail.callId,
    };
  }
  if (type === EVENT_TYPES.CALL_TRANSCRIPT) {
    return {
      kind: 'transcript',
      url: null,
      callId: detail.callId,
      icaluid: detail.callTranscriptICalUid || null,
    };
  }
  return null;
}

export async function downloadRecording(graph, evt) {
  if (!evt?.url) return null;
  const shareId = urlToShareId(evt.url);
  return graph.download(`/shares/${shareId}/driveItem/content`);
}

export async function tryDownloadTranscriptForRecording(graph, recordingUrl) {
  if (!recordingUrl) return null;
  const vttUrl = recordingUrl.replace(/\.mp4(\?|$)/i, '.transcript.vtt$1');
  if (vttUrl === recordingUrl) return null;
  try {
    const shareId = urlToShareId(vttUrl);
    return await graph.download(`/shares/${shareId}/driveItem/content`);
  } catch (err) {
    if (err.status === 404) return null;
    throw err;
  }
}

export async function tryFetchTranscriptViaOnlineMeetings(graph, joinWebUrl) {
  if (!joinWebUrl) return null;
  try {
    const meeting = await graph.request(
      `/me/onlineMeetings?$filter=JoinWebUrl eq '${encodeURIComponent(joinWebUrl).replace(/'/g, "''")}'`,
    );
    const om = meeting?.value?.[0];
    if (!om) return null;
    const transcripts = await graph.request(`/me/onlineMeetings/${om.id}/transcripts`);
    const first = transcripts?.value?.[0];
    if (!first) return null;
    return graph.download(`/me/onlineMeetings/${om.id}/transcripts/${first.id}/content?$format=text/vtt`);
  } catch (err) {
    if (err.status === 403 || err.status === 404) return null;
    throw err;
  }
}
